import React, { useEffect, useState } from 'react';
import moment from 'moment';

import Accordion from '../../../../components/Accordion';
import FormContainer from '../../../../components/FormContainer';
import InputInfo from '../../../../components/Inputs/Info';

import { getPlanos } from '../../../../services/v3/contrato-congenere';

import * as S from './styles';
import { useGlobal } from '../../../../contexts/Global/context';

const DATE_FORMAT = 'DD/MM/YYYY';

function mapHealthPlansToString(plans) {
    if (!plans.length) {
        return [' '];
    }

    return plans.filter((plan) => plan.descricaoPlanoCongenere).map((plan) => plan.descricaoPlanoCongenere);
}

function RelatorioCongenere({ congener, contractSearched }) {
    const { dataActiveContract } = useGlobal();

    const [healthInsurance, setHealthInsurance] = useState([]);

    useEffect(() => {
        async function loadHealthInsurance() {
            const response = await getPlanos({
                idContratoCongenere: congener.numeroContratoCongenere,
                idContratoEmpresa: contractSearched || dataActiveContract.numero,
            });
            setHealthInsurance(mapHealthPlansToString(response.congenere.planos));
        }
        loadHealthInsurance();
    }, []);

    const treatedStates = React.useMemo(() => {
        if (congener.state.length === 0) return [' '];
        if (congener.state.length < 5) return congener.state.join(', ');
        return congener.state.slice(0, 2).join(', ').concat('...');
    }, [congener.state]);
    const treatedCities = React.useMemo(() => {
        if (congener.city.length === 0) return [' '];
        if (congener.city.length < 5) return congener.city.join(', ');
        return congener.city.slice(0, 2).join(', ').concat('...');
    }, [congener.city]);

    return (
        <S.ContentData>
            <Accordion title={`Contrato da congênere - ${congener.numeroContratoCongenere}`} hasCollapse={false}>
                <FormContainer>
                    <InputInfo field={{ label: 'Congênere', value: congener.razaoSocialCongenere }} />
                    <InputInfo field={{ label: 'Situação do contrato', value: congener.situacaoContrato }} />
                    <InputInfo
                        field={{
                            label: 'Data final da situação do contrato',
                            value: moment(congener.dataFimVigencia).format(DATE_FORMAT),
                        }}
                    />
                    <InputInfo field={{ label: 'Nome fantasia da congênere', value: congener.nomeFantasiaCongenere }} />
                    <InputInfo
                        field={{
                            label: 'Data inicial da situação do contrato',
                            value: moment(congener.dataInicioVigencia).format(DATE_FORMAT),
                        }}
                    />
                    <InputInfo field={{ label: 'Planos', value: healthInsurance.join(', ') }} />
                    <InputInfo
                        field={{
                            label: 'Estado de atendimento',
                            value: treatedStates,
                        }}
                    />
                    <InputInfo
                        field={{
                            label: 'Município de atendimento',
                            value: treatedCities,
                        }}
                    />
                </FormContainer>
            </Accordion>
        </S.ContentData>
    );
}

export default RelatorioCongenere;
